/**
 * DevExtreme (esm/common/core/events/transform.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { exportNames } from "../../../__internal/events/m_transform";
export const {
  transformstart: transformstart,
  transform: transform,
  transformend: transformend,
  translatestart: translatestart,
  translate: translate,
  translateend: translateend,
  zoomstart: zoomstart,
  zoom: zoom,
  zoomend: zoomend,
  pinchstart: pinchstart,
  pinch: pinch,
  pinchend: pinchend,
  rotatestart: rotatestart,
  rotate: rotate,
  rotateend: rotateend
} = exportNames;